export const VIEWS = {
  READER: "READER",
  HIGHLIGHTS: "HIGHLIGHTS",
  ANSWERS: "ANSWERS",
  CARDS: "CARDS",
  COMBINED: "COMBINED"
};

export const CHAT_MESSAGES = {
  INTRO_MESSAGE:
    "Your assignment has two steps: First, highlight passages that are relevant to each question. Second, answer the questions based on your highlights. Let me know when you're done highlighting, and ready to analyze your highlights.",
  LAST_QUESTION: "seems like you're ready to review and submit"
};

export const CHAT_REGEX = {
  UUID: /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi, // matches interaction uuid like 5f150b39-658e-4271-a641-a725b47dfe1f
  ANSWER: /[Aa][Nn][Ss][Ww][Ee][Rr]/g, // matches "Answer" or "answer" both lower and upper case
  NEXT_QUESTION: /[Nn][Ee][Xx][Tt]\s+[Qq][Uu][Ee][Ss][Tt][Ii][Oo][Nn]/g // matches "Next Question" or "next question" both lower and upper case
};
